import React from "react";
import CardsBorder from "../../../components/Cards/CardsBorder";
import LicenceDetailPage from "../../License/LicenseDetailPage/LicenceDetailPage";

const CustomerLicense = () => {
  return (
    <div
      className="px-[40px] pt-2 mt-3"
      // style={{ padding: "40px", backgroundColor: "#fff" }}
    >
      <CardsBorder>
        <div>
          <p className="mx-8 font-semibold text-[17px]">
            License Details
          </p>
          <LicenceDetailPage customerLicense={true} />
        </div>
      </CardsBorder>
    </div>
  );
};

export default CustomerLicense;
